import { Component, OnInit, Input, Provider, DoCheck, Output, EventEmitter } from '@angular/core';
import { IRteListButtonItem, RteToolbarViewModel, RTEAlertService, RteDialog, BeforeSave, AfterGet } from 'rte-library';
import { EditorConfiguration, overlayMode } from 'codemirror';
import { QueryResult } from 'src/app/reports/models/query/query-result.model';
import { Entity } from '../entity.model';
import { ExplainPlanDialogComponent } from '../explain-plan-dialog/explain-plan-dialog.component';
import { QueryRequest } from 'src/app/reports/requests/query.request';
import { QueryPagedRequest } from 'src/app/reports/requests/query-paged.request';
import { QueryService } from 'src/app/reports/services/query.service';
import { getDescriptionValidationMessage, getProviderValidationMessage, getValidation} from '../entity.validation';
import { SchemaForm } from 'src/app/reports/shared/rte-form/schema/schema.model';
import { QueryResultDialogComponent } from '../query-result-dialog/query-result-dialog.component';
import { BaseComponent } from 'src/app/reports/shared/utils/base.component';

@Component({
  selector: 'app-entity-form',
  templateUrl: './entity-form.component.html',
  styleUrls: ['./entity-form.component.scss']
})
export class EntityFormComponent extends BaseComponent implements OnInit, DoCheck {

  //#region Properties
  codeMirrorOptions: EditorConfiguration = null;

  showCodeMirror = true;

  //#endregion

  //#region Inputs and Outputs

  @Input() toolbarObject: RteToolbarViewModel<Entity>;
  @Input() schemaForm: SchemaForm;

  @Output() queryResultChange: EventEmitter<QueryResult> = new EventEmitter<QueryResult>();

  //#endregion

  constructor(
    private alert: RTEAlertService,
    private queryService: QueryService,
    public dialog: RteDialog) {
      super();
    }

  ngOnInit() {
    this.configureCodeMirror();

    this.setToolbarEvents();
  }

  ngDoCheck() {
    this.codeMirrorOptions.readOnly = this.toolbarObject.readonlyBrowserMode;
  }

  //#region List Buttons

  configureCodeMirror() {
    this.codeMirrorOptions = {
      lineNumbers: true,
      theme: 'eclipse',
      mode: 'text/x-pgsql',
      extraKeys: { 'Ctrl-Space': 'autocomplete' },
      placeholder: 'Query'
    };
  }

  //#endregion

  //#region Dialogs

  showExplainPlan() {
    const obj: QueryRequest = {
      ProviderId: this.toolbarObject.current.Provider.Id,
      Query: this.toolbarObject.current.Query
    };

    this.subscription.add(
      this.queryService.explainPlan(obj).subscribe(result => {
        ((!result.Success) ? this.alert.error(result.Message) : this.openExplainModal(result.ExplainPlan));
      })
    );
  }

  showQueryResult() {
    const obj: QueryPagedRequest = {
      AmountByPage: 10,
      Page: 1,
      ProviderId: this.toolbarObject.current.Provider.Id,
      Query: this.toolbarObject.current.Query
    };

    this.subscription.add(
      this.queryService.queryResult(obj).subscribe(result => {
        ((!result.Success) ? this.alert.error(result.Message) : this.openQueryResultModal(result));
      })
    );
  }

  openExplainModal(value: string): void {
    this.dialog.customOpen(ExplainPlanDialogComponent, {
      minWidth: '550px !important',
      minHeight: '550px',
      data: value
    });
  }


  openQueryResultModal(queryResult: QueryResult) {
    this.dialog.customOpen(QueryResultDialogComponent, {
      minWidth: 'auto',
      minHeight: 'auto',
      maxWidth: '85%',
      maxHeight: '85%',
      data: queryResult
    });
  }

  //#endregion

  //#region Validation

  getDescriptionValidationMessage() {
    return getDescriptionValidationMessage(this.toolbarObject.current);
  }

  getProviderValidationMessage() {
    return getProviderValidationMessage(this.toolbarObject.current);
  }

  //#endregion

  //#region Toolbar Events

  setToolbarEvents() {
    const toolbarComponent = this.toolbarObject.toolbarComponent;
    this.subscription.add(toolbarComponent.validateBeforeSave.subscribe(beforeSave => this.validateBeforeSave(beforeSave)));
    this.subscription.add(toolbarComponent.customizeAfterInsertMode.subscribe(afterInsert => this.customizeAfterInsertMode(afterInsert)));
  }

  validateBeforeSave(beforeSave: BeforeSave) {
    const validation = getValidation(this.toolbarObject.current);

    if (validation) {
      beforeSave.cancelSave = true;
      this.alert.warning(validation);
    }
  }

  customizeAfterInsertMode(afterInsert: boolean) {
    if (afterInsert) {
      this.showCodeMirror = false;
      setTimeout(() => {
        this.showCodeMirror = true;
      });
    }
  }

  //#endregion
}
